import React, { useState } from 'react';
import addModifiers from 'utils/add_modifiers';
import { Spinner } from 'ui';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';

const ConfirmationModal = ({
  onDismiss,
  unassignedUserCount,
  onConfirm,
  loading,
}) => {
  const [assignNewUsers, updateAssignNewUsers] = useState(false);

  return (
    <AlertBox onDismiss={onDismiss}>
      <Heading children={t('triggers.confirm_modal.heading')} />
      <SubHeading
        children={t('triggers.confirm_modal.subheading', {
          count: unassignedUserCount,
        })}
      />
      <div className="FormGroup mt-24">
        <label htmlFor="assignNewUsers-false" className="mb-8">
          <input
            type="radio"
            id="assignNewUsers-false"
            name="assignNewUsers"
            checked={!assignNewUsers}
            onChange={() => updateAssignNewUsers(false)}
          />
          <span
            className="ml-8"
            children={t('triggers.confirm_modal.assign.no')}
          />
        </label>
        <label htmlFor="assignNewUsers-true">
          <input
            type="radio"
            id="assignNewUsers-true"
            name="assignNewUsers"
            checked={assignNewUsers}
            onChange={() => updateAssignNewUsers(true)}
          />
          <span
            className="ml-8"
            children={t('triggers.confirm_modal.assign.yes')}
          />
        </label>
      </div>
      <div className="d-f jc-e ai-c mt-24">
        <button
          type="button"
          className="u-linkBtn u-linkBtn--dark td-u"
          onClick={onDismiss}
          children={t('common.cancel')}
        />
        <button
          type="button"
          className={`ml-16
            ${addModifiers('CustomColor', [
              'backgroundColor',
              'buttonBoxShadow',
            ])}
            ${addModifiers('NewButton', ['yellow', 'tallAndWide'])}
          `}
          onClick={() => onConfirm({ assignNewUsers })}
        >
          {loading && <Spinner color="darker" className="mr-8" />}
          {t('triggers.labels.update')}
        </button>
      </div>
    </AlertBox>
  );
};

export default ConfirmationModal;
